module.exports = __webpack_public_path__ + "img/logo.15797728.png";